var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBook = function SvgBook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M16 2v4M8 2v4M12 22h-1c-3.771 0-5.657 0-6.828-1.172S3 17.771 3 14v-2c0-3.771 0-5.657 1.172-6.828S7.229 4 11 4h2c3.771 0 5.657 0 6.828 1.172S21 8.229 21 12v.5M3 10h18"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M17 22s4-1.853 4-4.861C21 15.958 20.159 15 19.2 15c-1.147 0-1.778.412-2.2 1.235-.422-.823-1.053-1.235-2.2-1.235-.959 0-1.8.958-1.8 2.139C13 20.147 17 22 17 22"
  })));
};
export default SvgBook;